import { Pipe } from '@angular/core';
import { createRound, isString } from '../utils/utils';
var CeilPipe = (function () {
    function CeilPipe() {
    }
    CeilPipe.prototype.transform = function (value, precision) {
        if (precision === void 0) { precision = 0; }
        if (isString(precision)) {
            precision = parseInt(precision);
        }
        return createRound('ceil')(value, precision);
    };
    return CeilPipe;
}());
export { CeilPipe };
CeilPipe.decorators = [
    { type: Pipe, args: [{
                name: 'ceil'
            },] },
];
/** @nocollapse */
CeilPipe.ctorParameters = function () { return []; };
//# sourceMappingURL=ceil.pipe.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular-pipes/esm/math/ceil.pipe.js
// module id = 260
// module chunks = 103